skrilla.filter('greyhoundsSAVenueNameFormatter', function () {
    return function (venueName) {
        if (venueName !== undefined && venueName !== null) {
            switch (venueName.toUpperCase()) {
                case "MURRAY BRIDGE STRAIGHT":
                    return "Murray Bridge"
                case "RICHMOND STRAIGHT":
                    return "Richmond"
                default:
                    return venueName
            }
        } return ""
    }
})
